// components/forms/DataProtectionInformationContactForm.jsx

import { Trans } from 'react-i18next';

const DataProtectionInformationContactForm = ({
  formData,
  handleChange,
  fontSize = '0.85em',
}) => {
  return (
    <div style={{ fontSize }}>
      {/* 🔹 Text d’informació legal 
      <p className="web-modal-text-muted">
        <Trans
          i18nKey="data_protection_register_form"
          components={{
            a1: (
              <a
                href="https://www.aepd.es/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Agencia Española de Protección de Datos
              </a>
            ),
            a2: (
              <a
                href="/legal-notice"
                target="_blank"
                rel="noopener noreferrer"
              >
                Legal Notice
              </a>
            ),
          }}
        />
      </p>*/}

      {/* 🔹 Checkbox d’acceptació */}
      <div className="web-modal-checkbox" style={{ marginTop: '0.5rem' }}>
        <label>
          <input
            type="checkbox"
            name="acceptPrivacyPolicy"
            checked={formData.acceptPrivacyPolicy}
            onChange={handleChange}
            required
          />
          <Trans
            i18nKey="accept_privacy_policy"
            components={{
              a: (
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Política de Privacitat
                </a>
              ),
            }}
          />
        </label>
      </div>
    </div>
  );
};

export default DataProtectionInformationContactForm;